"use client";

import { motion } from "framer-motion";
import { Mail, Phone } from "lucide-react";
import { useTranslations } from "next-intl";

import GlowButton from "@/components/sections/2026/ui/GlowButton";

import { useReveal } from "@/components/sections/2026/blog/parts/reveal";

// Shared closing CTA band — "Ready to build something great?" on neutral-900,
// with the two contact paths (email + phone) matching Commitment / the tech
// stack CTA. Sits above the global Footer2026 (rendered by SiteChrome), so this
// component intentionally renders no footer of its own.
export default function ReadyToBuildCTA() {
  const t = useTranslations("common");
  const { reveal } = useReveal({ amount: 0.4 });

  return (
    <section className="bg-neutral-900 px-6 py-16 text-white md:py-20">
      <div className="mx-auto flex max-w-[760px] flex-col items-center gap-5 text-center">
        <motion.h2
          {...reveal}
          custom={0}
          className="text-3xl font-bold th:leading-[1.35] md:text-4xl"
        >
          {t("readyCta.heading")}
        </motion.h2>
        <motion.p {...reveal} custom={1} className="text-base text-white/90">
          {t("readyCta.body")}
        </motion.p>
        <motion.div
          {...reveal}
          custom={2}
          className="mt-2 flex flex-wrap items-center justify-center gap-3.5"
        >
          <GlowButton href="mailto:pichan.s@celestialcode.io">
            <Mail className="h-5 w-5 shrink-0" aria-hidden />
            {t("cta.talkViaEmail")}
          </GlowButton>
          {/* Ghost — the secondary of the pair; see CommitmentSection. */}
          <GlowButton href="tel:0875003282" variant="ghost">
            <Phone className="h-5 w-5 shrink-0" aria-hidden />
            {t("cta.callUsNow")}
          </GlowButton>
        </motion.div>
      </div>
    </section>
  );
}
